import { Col, Container, Row } from "reactstrap";

const Description = () => {
  return (

          <Col lg={12} className="section" id="description">
            <div className="text-center w-75 mx-auto">
              <p className="user-review">
                <span className="fw-bold">Griffith College (Ireland)</span>,
                  adalah institusi pendidikan tinggi swasta terbesar di Irlandia, 
                  dengan kampus di Dublin, Cork, dan Limerick, yang menawarkan 
                  program sarjana, pascasarjana, dan profesional yang diakui secara 
                  internasional. Didirikan pada tahun 1974, perguruan tinggi ini 
                  telah memperoleh reputasi yang kuat dalam kesuksesan mahasiswa, 
                  dengan pengakuan global termasuk peringkat #243 dalam QS World 
                  University Ranking (2024) dan peringkat #46 dalam Times Higher 
                  Education (THE) ranking (2023) di kategorinya.
              </p>
            </div>
          </Col>

  );
};

export default Description;